import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b8113aa2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "checkbox",
  id: "btn-mas"
}, null, -1))
const _hoisted_3 = { class: "redes" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-list",
  _mstvisible: "2"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn-mas" }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "btn-mas",
    class: "fa fa-cog"
  })
], -1))
const _hoisted_6 = { class: "general" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Crear Enlace")
], -1))
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Datos Generales")
], -1))
const _hoisted_10 = { class: "grid" }
const _hoisted_11 = { class: "form-floating" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "DGII", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "ARS", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Otro", -1))
const _hoisted_15 = [
  _hoisted_12,
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "tipo" }, "Tipo:", -1))
const _hoisted_17 = { class: "form-floating" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "nombre" }, "Nombre:", -1))
const _hoisted_19 = { class: "form-floating" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "descripcion" }, "Descripción:", -1))
const _hoisted_21 = { class: "form-floating" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "enlace" }, "Enlace:", -1))
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Otros Datos")
], -1))
const _hoisted_25 = { class: "grid" }
const _hoisted_26 = { class: "form-floating" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "enlace" }, "Credenciales:", -1))
const _hoisted_28 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Navbar),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          class: "a yellow",
          to: "/enlaces"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      _hoisted_5
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("form", null, [
        _createElementVNode("fieldset", null, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _withDirectives(_createElementVNode("select", {
                  id: "tipo",
                  type: "tipo",
                  placeholder: "Tipo",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.enlace.tipo) = $event)),
                  class: "form-select",
                  autofocus: ""
                }, _hoisted_15, 512), [
                  [_vModelSelect, _ctx.enlace.tipo]
                ]),
                _hoisted_16
              ]),
              _createElementVNode("div", _hoisted_17, [
                _withDirectives(_createElementVNode("input", {
                  id: "nombre",
                  type: "nombre",
                  placeholder: "Nombre",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.enlace.nombre) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.enlace.nombre]
                ]),
                _hoisted_18
              ]),
              _createElementVNode("div", _hoisted_19, [
                _withDirectives(_createElementVNode("input", {
                  id: "descripcion",
                  type: "descripcion",
                  placeholder: "Descripción",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.enlace.descripcion) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.enlace.descripcion]
                ]),
                _hoisted_20
              ]),
              _createElementVNode("div", _hoisted_21, [
                _withDirectives(_createElementVNode("input", {
                  id: "enlace",
                  type: "enlace",
                  placeholder: "Enlace",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.enlace.enlace) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.enlace.enlace]
                ]),
                _hoisted_22
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _withDirectives(_createElementVNode("input", {
                  id: "credenciales",
                  type: "credenciales",
                  placeholder: "Credenciales",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.enlace.credenciales) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.enlace.credenciales]
                ]),
                _hoisted_27
              ])
            ])
          ]),
          _createElementVNode("button", {
            class: "btn btn-primary",
            onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.saveEnlace()), ["prevent"])),
            disabled: 
                  !_ctx.enlace.tipo ||
                  !_ctx.enlace.nombre ||
                  !_ctx.enlace.descripcion ||
                  !_ctx.enlace.enlace ||
                  !_ctx.enlace.credenciales
      
          }, "Guardar ", 8, _hoisted_28)
        ])
      ])
    ])
  ], 64))
}